import dayjs from "dayjs";

export const field = (row, name, fallback = undefined) => {
  if (!row) return fallback;
  if (row[name] !== undefined) return row[name];
  const pascal = `${name.charAt(0).toUpperCase()}${name.slice(1)}`;
  return row[pascal] !== undefined ? row[pascal] : fallback;
};

export const numberField = (row, name, fallback = 0) => {
  const value = Number(field(row, name, fallback));
  return Number.isFinite(value) ? value : fallback;
};

export const isoDate = (value) => dayjs(value).startOf("day").format("YYYY-MM-DD");
export const displayDate = (value) =>
  value && dayjs(value).isValid() ? dayjs(value).format("DD.MM.YYYY") : "";

export const normalizeLookup = (row) => ({
  id: numberField(row, "id"),
  name: field(row, "name", "")
});

export const normalizeLookups = (data) => {
  const notShowFood3 = Boolean(field(data, "notShowFood3", false));
  return {
    mealTypes: (field(data, "mealTypes", []) || []).map(normalizeLookup),
    parts: (field(data, "parts", []) || [])
      .map(normalizeLookup)
      .filter((part) => !notShowFood3 || part.id !== 3),
    halls: (field(data, "halls", []) || []).map(normalizeLookup),
    branches: (field(data, "branches", []) || []).map(normalizeLookup),
    notShowFood3,
    canChooseBranch: Boolean(field(data, "canChooseBranch", false))
  };
};

export const emptyLookups = normalizeLookups({});
export const lookupOptions = (rows) =>
  (rows || []).map((row) => ({ value: row.id, label: row.name }));

export const normalizeProduct = (row) => ({
  idTov: numberField(row, "idTov"),
  name: field(row, "name", field(row, "tovName", ""))
});

export const mealLabels = {
  1: "Завтрак",
  2: "Обед",
  3: "Полдник",
  4: "Ужин"
};

export const lawAllowed = (law, lawNumber) => {
  const index = lawNumber;
  if (!law || law.length <= index) return true;
  const value = Number(law[index]);
  return !Number.isFinite(value) || value === 1;
};

export const datesBetween = (beg, end) => {
  const result = [];
  let current = dayjs(beg).startOf("day");
  const last = dayjs(end).startOf("day");
  while (current.isValid() && !current.isAfter(last) && result.length < 93) {
    result.push(current);
    current = current.add(1, "day");
  }
  return result;
};

export const showError = (messageApi, error, fallback) =>
  messageApi.error(error?.message || fallback);
